import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { WhiteBadgeStyled } from '@/app/components/search/components/EvolutionCard/Badges/BaseBadge/styled.ts';

const WelcomeGiftOfferBadge = () => {
  const { t } = useTranslation();
  return <WhiteBadgeStyled dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.welcome_gift') }} />;
};

export default WelcomeGiftOfferBadge;
